import { useState } from "react";

function useSessionStorage<T>(key: string) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    let item;
    if (typeof window !== "undefined")
      item = window.sessionStorage.getItem(key);

    return item ? JSON.parse(item) : "";
  });

  const setValue = (value: T) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {}
  };

  return { storedValue, setValue };
}

export default useSessionStorage;
